module.exports = __webpack_public_path__ + "img/discount-star.159fa98b.svg";